import type { FilterOption } from '../index'

export const CLOSING_TIMES = ['24h', '7d', '30d'] as const

export const CLOSING_TIME_OPTIONS: FilterOption<string>[] = [
	{ label: '< 24 hours', value: '24h' },
	{ label: '< 7 days', value: '7d' },
	{ label: '< 30 days', value: '30d' },
]

export const PROBABILITY_OPTIONS: FilterOption<number>[] = [
	{ label: '> 40%', value: 40 },
	{ label: '> 60%', value: 60 },
	{ label: '> 80%', value: 80 },
	{ label: '> 95%', value: 95 },
	{ label: '> 99%', value: 99 },
]

export type RangeFilterOption = {
	label: string
	min: number
	max?: number // undefined means no upper limit
}

export const VOLUME_OPTIONS: RangeFilterOption[] = [
	{ label: '1K-10K', min: 1000, max: 10000 },
	{ label: '10K-100K', min: 10000, max: 100000 },
	{ label: '100K-1M', min: 100000, max: 1000000 },
	{ label: '>1M', min: 1000000 },
]

export const LIQUIDITY_OPTIONS: RangeFilterOption[] = [
	{ label: '1K-10K', min: 1000, max: 10000 },
	{ label: '10K-100K', min: 10000, max: 100000 },
	{ label: '100K-1M', min: 100000, max: 1000000 },
	{ label: '>1M', min: 1000000 },
]

export const MARKET_STATUS: FilterOption<string>[] = [
	{ label: 'Active only', value: 'active_markets' },
]

export const TRADING_STATUS: FilterOption<string>[] = [
	{ label: 'Tradable Onchain Only', value: 'tradable_onchain_only' },
]
